import { SelectOption } from "flicket-ui";
import { HeardAboutUsType, PaymentProvider } from "~graphql/sdk";

export const HEARD_ABOUT_US_OPTIONS: SelectOption[] = [
  {
    value: HeardAboutUsType.Billboard,
    label: HeardAboutUsType.Billboard.toString(),
  },
  {
    value: HeardAboutUsType.Email,
    label: HeardAboutUsType.Email.toString(),
  },
  {
    value: HeardAboutUsType.Radio,
    label: HeardAboutUsType.Radio.toString(),
  },
  {
    value: HeardAboutUsType.SocialMedia,
    label: "Social Media",
  },
  {
    value: HeardAboutUsType.WordOfMouth,
    label: "Word of mouth / Friends / Family",
  },
  {
    value: HeardAboutUsType.InternetSearch,
    label: "Google / Internet search",
  },
  {
    value: HeardAboutUsType.Other,
    label: HeardAboutUsType.Other.toString(),
  },
];

export type HeardAboutUsOption = SelectOption;

export const PAYMENT_PROVIDER_OPTIONS: SelectOption[] = [
  { value: PaymentProvider.Eftpos, label: "Eftpos" },
  { value: PaymentProvider.Invoice, label: "Invoice" },
  { value: PaymentProvider.Cash, label: "Cash" },
  { value: PaymentProvider.Other, label: "Other" },
];

export type PaymentProviderOption = SelectOption;
